import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { EwcBase } from '../base/ewc-base';

@customElement('ewc-card')
export class EwcCard extends EwcBase {
  @property({ type: Boolean })
  elevated = false;

  @property({ type: Boolean })
  bordered = true;

  @property({ type: Boolean })
  hoverable = false;

  @property({ type: Boolean })
  compact = false;

  static override get styles() {
    return [
      ...EwcBase.styles,
      css`
        :host {
          display: block;
          width: 100%;
        }

        .card {
          background-color: var(--ewc-bg-color);
          border-radius: var(--ewc-radius-lg);
          overflow: hidden;
          transition: all var(--ewc-transition);
        }

        :host([bordered]) .card {
          border: 1px solid var(--ewc-border-color);
        }

        :host([elevated]) .card {
          box-shadow: var(--ewc-shadow-md);
        }

        :host([hoverable]) .card {
          cursor: pointer;
        }

        :host([hoverable]) .card:hover {
          transform: translateY(-2px);
          box-shadow: var(--ewc-shadow-lg);
        }

        /* Card sections */
        .card-header {
          padding: 1.5rem;
          border-bottom: 1px solid var(--ewc-border-color);
        }

        :host([compact]) .card-header {
          padding: 1rem;
        }

        .card-header:empty {
          display: none;
        }

        .card-body {
          padding: 1.5rem;
        }

        :host([compact]) .card-body {
          padding: 1rem;
        }

        .card-footer {
          padding: 1.5rem;
          border-top: 1px solid var(--ewc-border-color);
          background-color: var(--ewc-bg-secondary);
        }

        :host([compact]) .card-footer {
          padding: 1rem;
        }

        .card-footer:empty {
          display: none;
        }

        /* Slotted content styling */
        ::slotted(h1),
        ::slotted(h2),
        ::slotted(h3),
        ::slotted(h4),
        ::slotted(h5),
        ::slotted(h6) {
          margin: 0;
          color: var(--ewc-text-color-default);
        }

        ::slotted(p) {
          margin: 0.5rem 0;
          color: var(--ewc-text-color-secondary);
        }

        ::slotted(p:first-child) {
          margin-top: 0;
        }

        ::slotted(p:last-child) {
          margin-bottom: 0;
        }
      `
    ];
  }

  render() {
    return html`
      <div class="card" part="base">
        <div class="card-header" part="header">
          <slot name="header"></slot>
        </div>
        <div class="card-body" part="body">
          <slot></slot>
        </div>
        <div class="card-footer" part="footer">
          <slot name="footer"></slot>
        </div>
      </div>
    `;
  }
}